/**
 * Pre-compiled es messages for Drawer
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Cerrar bandeja` };
